// eslint-disable-next-line prefer-const
let state = {
    showNavBar: false,
}
export default state
